import "../../_metronic/_assets/sass/pages/login/login-1.scss";
import { useMediaQuery } from "@material-ui/core";
import AuthFooter from "../components/AuthFooter";

const TermosUsoPoliticaPrivacidade = () => {
    const isMediumScreen = useMediaQuery("(max-width: 1366px)");

    const termos_de_uso = [
        {
            title: "1. Aceitação dos Termos",
            description: (
                <>
                    Ao acessar ou utilizar a plataforma <b>OliverAI</b>, desenvolvida e operada por <b>Laon Soluções em Tecnologia LTDA</b>, inscrita no CNPJ sob nº <b>17.598.274/0001-27</b>, com sede na <b>Rua Doutor Colares, 257, Andar 2 Sala 1, Centro, Ponta Grossa – PR, 84010-010</b>, você declara ter lido,
                    compreendido e aceitado integralmente os presentes Termos de Uso. Caso não concorde com qualquer cláusula, recomendamos que não utilize a plataforma.
                </>
            ),
            borderBottom: true,
        },
        {
            title: "2. Descrição do Serviço",
            description: (
                <>
                    O <b>OliverAI</b> é uma plataforma de ferramentas baseadas em inteligência artificial, incluindo (mas não se limitando a):
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>
                            Criação de <b>agentes personalizados</b>, treinados com conteúdos diversos (como documentos e links);
                        </li>
                        <li>
                            <b>Geração de imagens com IA</b> em estilos específicos;
                        </li>
                        <li>
                            <b>Interações com Experts IA</b> - agentes especializados em temas como criação de conteúdo, produtividade, entre outros.
                        </li>
                    </ul>
                    Outras funcionalidades, como gerador de vídeo, voz sintética, agentes automatizados e editores de cortes virais, estão em desenvolvimento e serão lançadas futuramente. O acesso à plataforma é disponibilizado mediante cadastro e autorização da equipe administrativa.
                </>
            ),
            borderBottom: true,
        },
        {
            title: "3. Cadastro e Elegibilidade",
            description: (
                <div className="d-flex flex-column">
                    <span>Para utilizar a plataforma, o usuário deve fornecer dados como nome, CPF, e-mail, telefone e outras informações necessárias à criação da conta. A Laon se reserva o direito de habilitar ou desabilitar funcionalidades conforme acordado previamente.</span>

                    <span style={{ marginBlock: "1rem" }}>Menores de 18 anos só poderão utilizar a plataforma com autorização expressa de seus responsáveis legais.</span>

                    <span>O usuário é responsável por manter suas informações atualizadas e zelar pela confidencialidade de suas credenciais de acesso.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "4. Contratação e Pagamento",
            description: (
                <div className="d-flex flex-column">
                    <span>O uso da plataforma está condicionado à contratação de planos negociados diretamente com a equipe da Laon. Não há planos públicos disponíveis, nem período de teste automático. A liberação de módulos e funcionalidades depende de acordo comercial prévio.</span>

                    <span style={{ marginTop: "1rem" }}>Todos os pagamentos são realizados fora da plataforma, de forma independente, com instruções e valores informados pela equipe administrativa.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "5. Conduta do Usuário",
            description: (
                <>
                    O usuário compromete-se a utilizar a plataforma de forma ética e legal, abstendo-se de:
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Utilizar ferramentas para fins ilícitos ou que infrinjam direitos de terceiros;</li>
                        <li>Compartilhar ou disseminar conteúdo ofensivo, difamatório, discriminatório ou ilegal;</li>
                        <li>Tentar acessar áreas ou recursos não autorizados da plataforma.</li>
                    </ul>
                    A violação destas condições poderá acarretar a exclusão definitiva da conta, a critério da Laon.{" "}
                </>
            ),
            borderBottom: true,
        },
        {
            title: "6. Propriedade Intelectual",
            description: (
                <div className="d-flex flex-column">
                    <span>A marca, identidade visual, funcionalidades e estrutura do OliverAI são de propriedade exclusiva da Laon Soluções em Tecnologia LTDA.</span>

                    <span style={{ marginTop: "1rem" }}>O conteúdo eventualmente gerado por meio da plataforma, incluindo imagens e respostas dos agentes, é de responsabilidade exclusiva do usuário. A Laon não reivindica propriedade sobre esse conteúdo, salvo quando houver outro contrato aplicável.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "7. Limitações de Uso e Isenção de Garantias",
            description: (
                <div className="d-flex flex-column">
                    <span>A plataforma não deve ser utilizada para fornecer diagnósticos médicos, orientação jurídica, serviços financeiros ou qualquer outro uso que exija certificação profissional.</span>

                    <span style={{ marginTop: "1rem" }}>O OliverAI é disponibilizado "como está", sem garantias quanto à precisão, confiabilidade ou adequação dos conteúdos gerados por inteligência artificial. A Laon não se responsabiliza por decisões tomadas com base nos resultados fornecidos pela plataforma.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "8. Cancelamento e Encerramento",
            description: `O usuário pode solicitar o encerramento da conta a qualquer momento. A Laon poderá cancelar contas em caso de uso indevido ou descumprimento dos Termos.`,
            borderBottom: true,
        },
        {
            title: "9. Atualizações dos Termos",
            description: `Estes Termos de Uso poderão ser modificados periodicamente. Em caso de alterações significativas, os usuários serão notificados por e-mail ou pela própria plataforma. O uso contínuo após essas mudanças implica concordância com os novos termos.`,
            borderBottom: true,
        },
        {
            title: "10. Legislação Aplicável e Foro",
            description: `Estes termos são regidos pelas leis brasileiras. Fica eleito o foro da comarca de domicílio do usuário para a resolução de qualquer disputa relacionada à plataforma.`,
            borderBottom: true,
        },
        {
            title: "11. Contato",
            description: (
                <>
                    Dúvidas, solicitações ou comunicações podem ser feitas através do e-mail:{" "}
                    <a className="link" href="mailto:dev@laonlabs.com">
                        dev@laonlabs.com
                    </a>
                </>
            ),
            borderBottom: false,
        },
    ];

    const politicas_de_privacidade = [
        {
            title: "1. Introdução",
            description: (
                <>
                    A presente Política de Privacidade tem como objetivo esclarecer como a <b>Laon Soluções em Tecnologia LTDA</b>, inscrita no CNPJ sob nº <b>17.598.274/0001-27</b>, com sede na <b>Rua Doutor Colares, 257, Andar 2 Sala 1, Centro, Ponta Grossa – PR, 84010-010</b>, coleta, utiliza, armazena e protege os
                    dados pessoais dos usuários da plataforma <b>OliverAI</b>. Ao utilizar a plataforma, o usuário declara estar ciente e de acordo com os termos desta Política.
                </>
            ),
            borderBottom: true,
        },
        {
            title: "2. Dados Pessoais Coletados",
            description: (
                <>
                    Durante o processo de cadastro e utilização da plataforma, poderão ser coletados os seguintes dados pessoais:
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Nome completo</li>
                        <li>CPF</li>
                        <li>CNPJ, razão social e nome fantasia (em caso de empresas)</li>
                        <li>E-mail </li>
                        <li>Telefone de contato </li>
                        <li>Informações relacionadas ao pagamento dos planos (como valor, status e data de vencimento) </li>
                    </ul>
                    A coleta desses dados ocorre no momento do cadastro ou por meio de contato direto com a equipe da Laon.{" "}
                </>
            ),
            borderBottom: true,
        },
        {
            title: "3. Finalidades do Tratamento",
            description: (
                <>
                    Os dados pessoais são tratados com as seguintes finalidades:
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Viabilizar o cadastro e a autenticação do usuário;</li>
                        <li>Fornecer acesso aos módulos contratados da plataforma;</li>
                        <li>Cumprir obrigações legais e regulatórias, inclusive fiscais;</li>
                        <li>Realizar o gerenciamento administrativo dos planos e pagamentos;</li>
                        <li>Assegurar a segurança e integridade da plataforma.</li>
                    </ul>
                </>
            ),
            borderBottom: true,
        },
        {
            title: "4. Base Legal para o Tratamento",
            description: (
                <>
                    O tratamento de dados pessoais realizado pelo Oliver AI tem como base legal:{" "}
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Execução de contrato, para viabilizar o uso da plataforma e suas funcionalidades;</li>
                        <li>Cumprimento de obrigação legal ou regulatória, especialmente no que se refere à emissão de notas fiscais e à guarda de registros;</li>
                        <li>Consentimento do usuário, especialmente nos casos em que o titular for menor de idade.</li>
                    </ul>
                </>
            ),
            borderBottom: true,
        },
        {
            title: "5. Menores de Idade",
            description: (
                <div className="d-flex flex-column">
                    <span>O uso da plataforma por menores de 18 anos só é permitido mediante autorização expressa dos responsáveis legais, os quais devem realizar ou acompanhar o cadastro e o uso da conta.</span>

                    <span style={{ marginTop: "1rem" }}>A Laon não realiza tratamento deliberado de dados pessoais de menores de idade sem essa autorização.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "6. Compartilhamento de Dados",
            description: (
                <>
                    Os dados pessoais tratados pela plataforma não são compartilhados com terceiros, exceto quando:
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Houver obrigação legal ou judicial para fornecimento das informações;</li>
                        <li>For necessário para o cumprimento de obrigações fiscais ou contratuais, como emissão de nota fiscal.</li>
                    </ul>
                    A Laon não comercializa, aluga ou transfere dados pessoais a terceiros.
                </>
            ),
            borderBottom: true,
        },
        {
            title: "7. Armazenamento e Segurança",
            description: (
                <div className="d-flex flex-column">
                    <span>Os dados são armazenados em ambiente seguro e controlado, com a adoção de medidas técnicas adequadas à proteção contra acessos não autorizados, vazamentos ou outras formas de uso indevido.</span>

                    <span style={{ marginTop: "1rem" }}>Utilizamos criptografia, autenticação por senha e controles de acesso para garantir a segurança da informação.</span>
                </div>
            ),
            borderBottom: true,
        },
        {
            title: "8. Direitos do Titular",
            description: (
                <>
                    Em conformidade com a Lei Geral de Proteção de Dados (LGPD), o usuário pode, a qualquer momento:
                    <ul style={{ marginBlock: "1rem" }}>
                        <li>Solicitar acesso aos dados armazenados;</li>
                        <li>Corrigir dados incompletos, inexatos ou desatualizados;</li>
                        <li>Solicitar a exclusão ou anonimização dos dados, quando aplicável;</li>
                        <li>Solicitar a portabilidade dos dados para outro fornecedor de serviço.</li>
                    </ul>
                    As solicitações podem ser feitas diretamente pelo e-mail:{" "}
                    <a href="mailto:dev@laonlabs.com" className="link">
                        dev@laonlabs.com
                    </a>
                </>
            ),
            borderBottom: true,
        },
        {
            title: "9. Alterações na Política",
            description: `Esta Política de Privacidade poderá ser atualizada periodicamente para refletir mudanças legislativas, operacionais ou tecnológicas. Alterações relevantes serão comunicadas aos usuários através da plataforma ou por e-mail.`,
            borderBottom: true,
        },
        {
            title: "10. Contato",
            description: (
                <>
                    Em caso de dúvidas, solicitações ou exercício de direitos relativos aos dados pessoais, entre em contato com a Laon através do e-mail:{" "}
                    <a href="mailto:dev@laonlabs.com" className="link">
                        dev@laonlabs.com
                    </a>
                </>
            ),
            borderBottom: false,
        },
    ];

    return (
        <div style={{ flex: "1 1", backgroundColor: "#111928" }}>
            <div style={{ padding: isMediumScreen ? "60px 10dvw" : "120px 15dvw", textAlign: isMediumScreen ? "center" : undefined, backgroundImage: "url(/images/TermosHeaderBackground.svg)", backgroundRepeat: "no-repeat", backgroundPosition: "top", backgroundSize: "cover" }} class="authContainer">
                <span className="tt-32 semibold color-white">Termos de Uso e Política de Privacidade</span>

                <span className="tt-18 color-dark-7">Publicado em: 20/06/2025</span>
            </div>

            <div style={{ paddingInline: isMediumScreen ? "10dvw" : "15dvw" }}>
                <div style={{ padding: isMediumScreen ? "32px 0px" : "80px 0px 32px 0px", borderBottom: "1px solid #7F59D9" }}>
                    <span className="tt-32 semibold color-white">Termos de Uso</span>
                </div>

                {termos_de_uso.map((item, idx) => (
                    <div key={`termo${idx}`} className="pbl-40 d-flex flex-column gap-24" style={{ borderBottom: item.borderBottom ? "1px solid #374151" : undefined }}>
                        <span className="tt-24 semibold color-white">{item.title}</span>

                        <span className="tt-18 color-dark-7">{item.description}</span>
                    </div>
                ))}

                <div style={{ padding: isMediumScreen ? "32px 0px" : "80px 0px 32px 0px", borderBottom: "1px solid #7F59D9" }}>
                    <span className="tt-32 semibold color-white">Política de Privacidade</span>
                </div>

                {politicas_de_privacidade.map((item, idx) => (
                    <div key={`politica${idx}`} className="pbl-40 d-flex flex-column gap-24" style={{ borderBottom: item.borderBottom ? "1px solid #374151" : undefined }}>
                        <span className="tt-24 semibold color-white">{item.title}</span>

                        <span className="tt-18 color-dark-7">{item.description}</span>
                    </div>
                ))}
            </div>

            <AuthFooter />
        </div>
    );
};

export default TermosUsoPoliticaPrivacidade;
